module.exports = __webpack_public_path__ + "static/media/home-banner-app.21b3700f.svg";